import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface IPresetSelectorProps {
  value: string;
  onChange: (val: string) => void;
}

const PresetSelector = (props: IPresetSelectorProps) => {
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="preset-label">Tipo de Paquetería</InputLabel>
      <Select
        labelId="preset-label"
        label="Tipo de Paquetería"
        value={props.value}
        onChange={(e) => props.onChange(e.target.value as string)}
      >
        <MenuItem value="small_parcel">Small Parcel</MenuItem>
        <MenuItem value="standard_parcel">Standard Parcel</MenuItem>
        <MenuItem value="big_parcel">Big Parcel</MenuItem>
      </Select>
    </FormControl>
  );
};

export default PresetSelector;
